import { useUrlSearchParams } from '@vueuse/core'

export const searchParams = useUrlSearchParams('history');
